import { createFileRoute } from "@tanstack/react-router";
import { AcceptInvitationPage } from "@/features/invitations";

/** Public: the emailed token is the credential. No sign-in required to get here. */
export const Route = createFileRoute("/invite/$token")({
  component: AcceptInvite,
});

function AcceptInvite() {
  const { token } = Route.useParams();
  return <AcceptInvitationPage token={token} />;
}
